/* eslint-disable no-new */
import WxConfig from '@/assets/js/WxConfig';
import ElementPlus from 'element-plus';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import { Area, Button, Cell, Checkbox, Collapse, CollapseItem, DatePicker, Dialog, DropdownItem, DropdownMenu, Empty, Field, FloatingBubble, Icon, Lazyload, List, Loading, NoticeBar, NumberKeyboard, PasswordInput, Picker, Popover, Popup, Progress, Radio, RadioGroup, Rate, Sidebar, SidebarItem, Slider, Swipe, SwipeItem, Switch, Tab, Tabs, Image as VanImage } from 'vant';
import 'vant/lib/index.css';
import { createApp } from 'vue';
import VueCookies from 'vue-cookies';
import wx from 'weixin-js-sdk';
import App from './App.vue';
import router from './router';
import store from './store';
// import { ElTooltip } from 'element-plus';
import { VUE_APP_VERSION } from '@/api/url';
import 'element-plus/dist/index.css';
import Masonry from 'masonry-layout';
import VueLazyload from 'vue-lazyload';
import { VueMasonryPlugin } from 'vue-masonry';
// import { Document } from '@element-plus/icons-vue'; // 引入 Edit 图标
// import copy from 'v-copy';
// 引入 Vconsole
// import VConsole from 'vconsole';
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});
export default {
  inserted (el, binding) {
    const masonry = new Masonry(el, {
      itemSelector: '.grid-item',
      columnWidth: 200,
      gutter: 10
    });

    // 将 Masonry 实例挂载到元素上
    el.masonry = masonry;
  },
  update (el) {
    if (el.masonry) {
      el.masonry.layout();
    }
  }
};
//  在dev环境使用
// if (process.env.NODE_ENV === 'development') {
// new VConsole();
// };
const app = createApp(App);
app.config.globalProperties.$wxConfig = WxConfig;
app.config.globalProperties.wx = wx;
app.use(store).use(router).use(VueCookies);
app.use(Field).use(RadioGroup).use(Radio).use(DropdownMenu).use(DropdownItem).use(List).use(Popup).use(Picker).use(DatePicker).use(Checkbox).use(Area).use(Cell).use(Switch).use(PasswordInput).use(NumberKeyboard).use(Rate).use(Loading).use(VanImage).use(Dialog).use(Button).use(Progress).use(Icon).use(Empty).use(Sidebar).use(SidebarItem).use(Slider).use(Popover).use(FloatingBubble).use(Tab).use(Tabs).use(Collapse).use(CollapseItem).use(NoticeBar).use(Swipe).use(SwipeItem).use(Lazyload, {
  loading: 'https://img.yzcdn.cn/vant/loading.png', // 加载时的占位图
  error: 'https://fastly.jsdelivr.net/npm/@vant/assets/apple-8.jpeg' // 加载失败时的占位图
});
// 配置 vue-lazyload
app.use(VueLazyload, {
  preLoad: 1.3, // 预加载高度（视口的倍数）
  // error: 'https://via.placeholder.com/300x400?text=加载失败', // 加载失败时的占位图
  // loading: 'https://via.placeholder.com/300x400?text=加载中...', // 加载中的占位图
  attempt: 3 // 图片加载失败时的重试次数
});
app.use(ElementPlus, { locale: zhCn });
app.use(VueMasonryPlugin);

const version = VUE_APP_VERSION || '1.0.0';
const lastVersion = localStorage.getItem('app-version');

if (lastVersion && lastVersion !== version) {
  localStorage.setItem('app-version', version);
  window.location.reload({ cache: 'reload' });// 强制刷新
} else {
  localStorage.setItem('app-version', version);
}
// app.use(ElTooltip);
// app.component(Document.name, Document); // 全局注册 Edit 图标
// app.use(copy);
app.mount('#app');
